import React from "react";

const ProfileCard = ({
  initials,
  title,
  subtitle,
  backgroundColor = "#f2f5f8",
  iconColor = "blue",
  border = "no-border",
}) => {
  return (
    <div className="draw__tile" style={{ padding: "16px", backgroundColor, border }}>
      <div
        className={`entities__item__icon entities__item__icon_font-size-18 entities__item__icon--${iconColor}`}
      >
        {initials}
      </div>
      <div className="entities__item__details">
        <div className="entities__item__details__title">{title}</div>
        <div className="entities__item__details__subtitle t--md t--navyblue">{subtitle}</div>
      </div>
    </div>
  );
};

export default ProfileCard;
